import List from "../../containers/Referrers/List";
import Entry from "../../containers/Referrers";

const referrerRoutes = [
  {
    path: "/referrers",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/referrers/:type",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/referrers/:type/:id",
    exact: true,
    auth: true,
    component: Entry
  }
];

export default referrerRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/referrers.jsx